import React from 'react';
import PropTypes from 'prop-types';

const CustomProgressBar = props => {
	const { pages } = props;
	return (
		<>
			<div className='stepwizard mb-5'>
				<div className='stepwizard-row'>
					{pages.map(page => (
						<a className={page.state} href={page.href} key={page.key}>
							<span className='stepwizard-badge' />
							<span className='stepwizard-title'>{page.title}</span>
						</a>
					))}
				</div>
			</div>
		</>
	)
}

CustomProgressBar.propTypes = {
	pages: PropTypes.array
}

export default CustomProgressBar;